import { PROVIDER_INFO } from "state/actions/provider";
import { TrustlyInfo } from "types";
import createReducer from "./createReducer";

export default createReducer<TrustlyInfo>({
  successType: PROVIDER_INFO,
});
